var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"list-delivery-summary"},_vm._l((_vm.inProgressDeliveryList),function(delivery,index){return _c('DeliverySummary',{key:index,staticClass:"delivery-summary",attrs:{"deliveryInfo":delivery}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }